/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Loading_DatesInputs */

const en_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading available dates…`)
};

const es_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando fechas disponibles…`)
};

const de_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Termine werden geladen…`)
};

const zh_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载可用日期…`)
};

const ar_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل التواريخ المتاحة…`)
};

const fr_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des dates disponibles…`)
};

const vi_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải ngày còn trống…`)
};

const sw_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia tarehe zinazopatikana…`)
};

const th_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดวันที่ว่าง…`)
};

const bs_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitavanje dostupnih datuma…`)
};

const ja_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約可能な日付を読み込み中…`)
};

const ko_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약 가능한 날짜를 불러오는 중…`)
};

const pt_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando as datas disponíveis…`)
};

const it_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento delle date disponibili…`)
};

const sv_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar tillgängliga datum…`)
};

const nl_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschikbare data laden…`)
};

const da_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser tilgængelige datoer…`)
};

const nb_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster inn tilgjengelige datoer…`)
};

const fi_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan käytettävissä olevat päivämäärät…`)
};

const pl_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie dostępnych dat…`)
};

const ru_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка доступных дат…`)
};

const tr_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut tarihler yükleniyor…`)
};

const hi_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध तिथियाँ लोड हो रही हैं…`)
};

const id_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat tanggal yang tersedia…`)
};

const ms_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuatkan tarikh yang tersedia…`)
};

const cs_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrávám dostupná data…`)
};

const el_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φόρτωση διαθέσιμων ημερομηνιών…`)
};

const he_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען תאריכים פנויים…`)
};

const af_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laai tans beskikbare datums…`)
};

const hu_booking_loading_dates = /** @type {(inputs: Booking_Loading_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A rendelkezésre álló időpontok betöltése…`)
};

/**
* | output |
* | --- |
* | "Loading available dates…" |
*
* @param {Booking_Loading_DatesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_loading_dates = /** @type {((inputs?: Booking_Loading_DatesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Loading_DatesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_loading_dates(inputs)
	if (locale === "de") return de_booking_loading_dates(inputs)
	if (locale === "zh") return zh_booking_loading_dates(inputs)
	if (locale === "ar") return ar_booking_loading_dates(inputs)
	if (locale === "fr") return fr_booking_loading_dates(inputs)
	if (locale === "vi") return vi_booking_loading_dates(inputs)
	if (locale === "sw") return sw_booking_loading_dates(inputs)
	if (locale === "th") return th_booking_loading_dates(inputs)
	if (locale === "bs") return bs_booking_loading_dates(inputs)
	if (locale === "ja") return ja_booking_loading_dates(inputs)
	if (locale === "ko") return ko_booking_loading_dates(inputs)
	if (locale === "pt") return pt_booking_loading_dates(inputs)
	if (locale === "it") return it_booking_loading_dates(inputs)
	if (locale === "sv") return sv_booking_loading_dates(inputs)
	if (locale === "nl") return nl_booking_loading_dates(inputs)
	if (locale === "da") return da_booking_loading_dates(inputs)
	if (locale === "nb") return nb_booking_loading_dates(inputs)
	if (locale === "fi") return fi_booking_loading_dates(inputs)
	if (locale === "pl") return pl_booking_loading_dates(inputs)
	if (locale === "ru") return ru_booking_loading_dates(inputs)
	if (locale === "tr") return tr_booking_loading_dates(inputs)
	if (locale === "hi") return hi_booking_loading_dates(inputs)
	if (locale === "id") return id_booking_loading_dates(inputs)
	if (locale === "ms") return ms_booking_loading_dates(inputs)
	if (locale === "cs") return cs_booking_loading_dates(inputs)
	if (locale === "el") return el_booking_loading_dates(inputs)
	if (locale === "he") return he_booking_loading_dates(inputs)
	if (locale === "af") return af_booking_loading_dates(inputs)
	if (locale === "hu") return hu_booking_loading_dates(inputs)
	return en_booking_loading_dates(inputs)
});